<template>
  <el-dialog
    width="1200px"
    title="Listing复用"
    :visible="visible"
    :close-on-click-modal="false"
    @close="close"
  >
    <span class="tips">注意：需优化文本内容后，手动操作上传</span>

    <el-table
      v-loading="tableLoading"
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{ textAlign: 'center' }"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        width="50"
        type="selection"
        align="center"
      ></el-table-column>
      <el-table-column label="图片" width="200" align="center">
        <template slot-scope="scope">
          <div class="imgList">
            <template v-for="(item, index) in scope.row.imageList || []">
              <el-popover
                :key="index + 'image'"
                trigger="hover"
                placement="right"
                :open-delay="600"
              >
                <img :src="item" class="prduct_img" alt />
                <div class="scope_img" slot="reference">
                  <img :src="item" alt />
                </div>
              </el-popover>
            </template>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="title"
        label="标题"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="platformName"
        label="上架平台"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="releaseStatus"
        label="销售状态"
        width="150"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="weight"
        label="平台售价"
        width="150"
        align="center"
      ></el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close" :disabled="saveDisabled">取消</el-button>
      <el-button type="primary" @click="save" :disabled="saveDisabled"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";

export default {
  name: "listingMultiplex",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    roleInfo: {
      type: Object,
      default: () => {},
    },
    currentForm: {
      type: Object,
      default: () => {},
    },
    parentSelectRows: {
      type: Array,
      default: () => [],
    },
    multiplexType: {
      type: String,
      default: "single",
    },
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      selectRows: [], //选中的列表
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleSelectionChange(rows) {
      this.selectRows = rows;
    },
    getList() {
      const API =
        Baseurl + "baseProductController/selectGeneralProductByProductId";
      const sendData = {
        staffId: this.roleInfo.rid,
      };
      if (this.multiplexType === "single") {
        sendData.productIdList = [this.currentForm?.productId];
      } else {
        sendData.productIdList = this.parentSelectRows?.map(
          (ele) => ele.productId
        );
      }
      this.tableLoading = true;
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.tableData = data;
            console.log(this.tableData);
          } else {
            this.$message.error(data);
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    close() {
      this.$emit("cancelVisible");
    },

    save() {
      if (this.selectRows?.length <= 0) {
        this.$message.warning("请先选择数据");
      } else {
        this.$emit("save", this.selectRows);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tips {
  color: #f56c6c;
  display: block;
  margin-bottom: 10px;
}
div.imgList {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: space-around;
}
.prduct_img {
  width: 500px;
  height: 500px;
}
.scope_img {
  width: 55px;
  height: 55px;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
